<template>
  <HeaderSection/>
  <BannerSection/>
  <HabilitiesSection/>
  <ResumeSection/>
  <ExperienceSection/>
  <FooterSection/>
</template>

<script lang="ts" setup>
import BannerSection from './components/BannerSection.vue';
import ExperienceSection from './components/ExperienceSection.vue';
import FooterSection from './components/FooterSection.vue';
import HabilitiesSection from './components/HabilitiesSection.vue';
import HeaderSection from './components/HeaderSection.vue'
import ResumeSection from './components/ResumeSection.vue';
</script>

<style>
</style>
